import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: "55qc9ajb",
  dataset: "production",
  useCdn: true,
})
